import React from 'react'
import { useTranslation } from 'react-i18next'
import ReactCountryFlag from 'react-country-flag'
import s from './LanguageSwitcher.module.css'

const languages = [
  { code: 'en', countryCode: 'GB' }, // английский
  { code: 'ru', countryCode: 'RU' }, // русский
  { code: 'tr', countryCode: 'TR' }, // турецкий
]

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation()

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  return (
    <div className={s.langSwitcher}>
      {languages.map((lng) => (
        <button
          key={lng.code}
          onClick={() => changeLanguage(lng.code)}
          className={`${s.langBtn} ${
            i18n.language === lng.code ? s.active : ''
          }`}
        >
          <ReactCountryFlag
            countryCode={lng.countryCode}
            svg
            style={{ fontSize: '2rem', lineHeight: '2rem' }}
          />
        </button>
      ))}
    </div>
  )
}